<template>
    <dl class="description-list-wrapper">
        <DescriptionItem :label="$t('기업명')">
            {{ detailData.company_name || '-' }}
        </DescriptionItem>
        <DescriptionItem :label="$t('기업명 (영문)')">
            {{ detailData.company_name_en || '-' }}
        </DescriptionItem>

        <DescriptionItem :label="$t('사업자등록번호')">
            {{ detailData.company_code || '-' }}
        </DescriptionItem>

        <DescriptionItem :label="$t('국가')">
            {{ detailData.country || '-' }}
        </DescriptionItem>
        <DescriptionItem :label="$t('국가 (영문)')">
            {{ detailData.country_en || '-' }}
        </DescriptionItem>
        
        <DescriptionItem :label="$t('주소')">
            {{ detailData.company_address || '-' }}
        </DescriptionItem>

        <DescriptionItem :label="$t('전화번호')">
            {{ detailData.company_tel || '-' }}
        </DescriptionItem>

        <DescriptionItem :label="$t('원청사 유무')">
            <h6 class="mb-0">
                <b-badge class="fw-400" :variant="detailData.client ? 'primary' : 'secondary'">
                    {{ detailData.client ? '원청사' : '평가대상 협력사' }}
                </b-badge>
            </h6>
        </DescriptionItem>
        <DescriptionItem :label="$t('에코바디스 여부')">
            <h6 class="mb-0">
                <b-badge class="fw-400" :variant="detailData.client ? 'primary' : 'secondary'">
                    {{ detailData.eco_vadis ? '원청사' : '평가대상 협력사' }}
                </b-badge>
            </h6>
        </DescriptionItem>

        <div class="row-wrapper">
            <DescriptionItem :label="$t('등록일시')">
                {{ detailData.created_at || '-' }}
            </DescriptionItem>

            <DescriptionItem :label="$t('수정일시')">
                {{ detailData.updated_at || '-' }}
            </DescriptionItem>
        </div>
    </dl>
</template>

<script>
import DescriptionItem from '@shared/components/common/DescriptionItem.vue';

export default {
    name: 'CompanyDetail',
    components: {
        DescriptionItem
    },
    props: {
        detailData: {
            type: Object,
            required: true,
            default: () => ({id: null}),
        }
    },
};
</script>
<style lang="scss" scoped>

</style>
